import { ReviewBox } from '@doist/marketist';
import Interpolate from 'components/Interpolate/Interpolate';
import { ReviewsGrid as Grid } from 'components/reviews-grid/reviews-grid';
import { useTranslation } from 'next-i18next';
function ReviewsGrid() {
  const backgroundImage = `${process.env.NEXT_PUBLIC_BASE_URL}/static/help/reviews-bg-blue.png`;
  const reviews = {
    carmen: {
      author: 'reviews.carmen.author',
      quote: 'reviews.carmen.quote'
    },
    ray: {
      author: 'reviews.ray.author',
      quote: 'reviews.ray.quote'
    },
    didier: {
      author: 'reviews.didier.author',
      quote: 'reviews.didier.quote'
    },
    amay: {
      author: 'reviews.amay.author',
      quote: 'reviews.amay.quote'
    },
    gonzalo: {
      author: 'reviews.gonzalo.author',
      quote: 'reviews.gonzalo.quote'
    },
    nicole: {
      author: 'reviews.nicole.author',
      quote: 'reviews.nicole.quote'
    },
    lelana: {
      author: 'reviews.lelana.author',
      quote: 'reviews.lelana.quote'
    },
    lisa: {
      author: 'reviews.lisa.author',
      quote: 'reviews.lisa.quote'
    }
  };
  return <Grid backgroundImage={backgroundImage} data-sentry-element="Grid" data-sentry-component="ReviewsGrid" data-sentry-source-file="reviews-grid.tsx">
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Review {...reviews.carmen} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
                <Review {...reviews.ray} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Review {...reviews.didier} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
                <Review {...reviews.amay} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Review {...reviews.gonzalo} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
                <Review {...reviews.nicole} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
            <Grid.Column data-sentry-element="unknown" data-sentry-source-file="reviews-grid.tsx">
                <Review {...reviews.lelana} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
                <Review {...reviews.lisa} data-sentry-element="Review" data-sentry-source-file="reviews-grid.tsx" />
            </Grid.Column>
        </Grid>;
}
function Review({
  author,
  quote
}: {
  author: string;
  quote: string;
}) {
  const {
    t
  } = useTranslation('helpcenter');
  return <ReviewBox citation={<ReviewBox.GeneralCitation title="" name={t(author)} />} data-sentry-element="ReviewBox" data-sentry-component="Review" data-sentry-source-file="reviews-grid.tsx">
            <Interpolate t={t} i18nKey={quote} data-sentry-element="Interpolate" data-sentry-source-file="reviews-grid.tsx" />
        </ReviewBox>;
}
export { ReviewsGrid };